export function formatRupeePrice(price) {
    let num = Number(String(price).replace(/,/g, ''));
    return Number(num.toFixed(0)).toLocaleString('en-IN');
}
